import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';

import { WindowService } from '../../shared/services/window.service';
import { cryptoApiAvailableFactory } from './crypto-api-available.factory';

export const CRYPTO_API_AVAILABLE = new InjectionToken<boolean>('CRYPTO_API_AVAILABLE', {
    providedIn: 'root',
    factory: () => cryptoApiAvailableFactory(inject(WindowService), inject(PLATFORM_ID))
});
